// import React, { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { useNavigate, useParams } from 'react-router-dom';
// import { doctorVerifyEmail } from '../../../redux/middleware/user/doctor/verification';
// import { Box, CircularProgress } from '@mui/material';
// import { toast } from 'react-toastify';

// const VerifyEmail = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { uidb64, token } = useParams(); // Get parameters from URL path

//   useEffect(() => {
//     const verifyEmail = async () => {
//       try {
//         await dispatch(doctorVerifyEmail(uidb64, token));
//         // Show success toast and redirect
//         toast.success('Email verification successful! Please login to continue.', {
//           position: "top-center"
//         });
//         navigate('/app/doctor_login');
//       } catch (error) {
//         // Show error toast and redirect
//         toast.error('Email verification failed. Please contact support for assistance.', {
//           position: "top-center"
//         });
//         navigate('/app/doctor_login');
//       }
//     };

//     if (uidb64 && token) {
//       verifyEmail();
//     }
//   }, [uidb64, token, dispatch, navigate]);

//   // Show loading spinner while verification is in progress
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         minHeight: '100vh',
//         backgroundColor: '#f5f5f5'
//       }}
//     >
//       <CircularProgress />
//     </Box>
//   );
// };

// export default VerifyEmail;

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';

const VerifyEmail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { uidb64, token } = useParams();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Make direct API call instead of using Redux
        const response = await fetch(`/api/auth1/activate/${uidb64}/${token}/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        const data = await response.json();

        if (response.ok) {
          toast.success('Email verification successful! Please login to continue.');
          navigate('/app/doctor/login');
        } else {
          throw new Error(data.error || 'Verification failed');
        }
      } catch (error) {
        console.error('Verification error:', error);
        toast.error(error.message || 'Email verification failed');
        navigate('/app/doctor/login');
      }
    };

    if (uidb64 && token) {
      verifyEmail();
    }
  }, [uidb64, token, navigate]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  );
};

export default VerifyEmail;
